import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  LIST_getInstance2xmlsct1exo3w as LIST_getInstance,
  MAP_getInstance173r3f2itu405 as MAP_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetClassDescClass;
function LinkedHashSetClassDesc() {
  if (LinkedHashSetClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      k1n() {
        return 'kotlin.collections.LinkedHashSet';
      }
    }
    initMetadataForClass($, 'LinkedHashSetClassDesc');
    LinkedHashSetClassDescClass = $;
  }
  return LinkedHashSetClassDescClass;
}
var ArrayListClassDescClass;
function ArrayListClassDesc() {
  if (ArrayListClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      k1n() {
        return 'kotlin.collections.ArrayList';
      }
    }
    initMetadataForClass($, 'ArrayListClassDesc');
    ArrayListClassDescClass = $;
  }
  return ArrayListClassDescClass;
}
var HashSetClassDescClass;
function HashSetClassDesc() {
  if (HashSetClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      k1n() {
        return 'kotlin.collections.HashSet';
      }
    }
    initMetadataForClass($, 'HashSetClassDesc');
    HashSetClassDescClass = $;
  }
  return HashSetClassDescClass;
}
var HashMapClassDescClass;
function HashMapClassDesc() {
  if (HashMapClassDescClass === VOID) {
    class $ extends MapLikeDescriptor() {
      constructor(keyDesc, valueDesc) {
        super('kotlin.collections.HashMap', keyDesc, valueDesc);
      }
    }
    initMetadataForClass($, 'HashMapClassDesc');
    HashMapClassDescClass = $;
  }
  return HashMapClassDescClass;
}
var LinkedHashMapClassDescClass;
function LinkedHashMapClassDesc() {
  if (LinkedHashMapClassDescClass === VOID) {
    class $ extends MapLikeDescriptor() {
      constructor(keyDesc, valueDesc) {
        super('kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
      }
    }
    initMetadataForClass($, 'LinkedHashMapClassDesc');
    LinkedHashMapClassDescClass = $;
  }
  return LinkedHashMapClassDescClass;
}
var ArrayClassDescClass;
function ArrayClassDesc() {
  if (ArrayClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      k1n() {
        return 'kotlin.Array';
      }
    }
    initMetadataForClass($, 'ArrayClassDesc');
    ArrayClassDescClass = $;
  }
  return ArrayClassDescClass;
}
var ListLikeDescriptorClass;
function ListLikeDescriptor() {
  if (ListLikeDescriptorClass === VOID) {
    class $ {
      constructor(elementDescriptor) {
        this.k1t_1 = elementDescriptor;
        this.l1t_1 = 1;
      }
      d1p() {
        return LIST_getInstance();
      }
      f1p() {
        return this.l1t_1;
      }
      h1p(index) {
        return index.toString();
      }
      i1p(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().o2(name + ' is not a valid list index');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      l1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.k1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().o2(toString(message));
        }
        return false;
      }
      j1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.k1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().o2(toString(message));
        }
        return emptyList();
      }
      k1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.k1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().o2(toString(message));
        }
        return this.k1t_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListLikeDescriptor()))
          return false;
        if (equals(this.k1t_1, other.k1t_1) && this.k1n() === other.k1n())
          return true;
        return false;
      }
      hashCode() {
        return imul(hashCode(this.k1t_1), 31) + getStringHashCode(this.k1n()) | 0;
      }
      toString() {
        return this.k1n() + '(' + toString(this.k1t_1) + ')';
      }
    }
    protoOf($).w1o = get_isNullable;
    protoOf($).e1p = get_isInline;
    protoOf($).g1p = get_annotations;
    initMetadataForClass($, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor()]);
    ListLikeDescriptorClass = $;
  }
  return ListLikeDescriptorClass;
}
var MapLikeDescriptorClass;
function MapLikeDescriptor() {
  if (MapLikeDescriptorClass === VOID) {
    class $ {
      constructor(serialName, keyDescriptor, valueDescriptor) {
        this.q1t_1 = serialName;
        this.r1t_1 = keyDescriptor;
        this.s1t_1 = valueDescriptor;
        this.t1t_1 = 2;
      }
      k1n() {
        return this.q1t_1;
      }
      d1p() {
        return MAP_getInstance();
      }
      f1p() {
        return this.t1t_1;
      }
      h1p(index) {
        return index.toString();
      }
      i1p(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().o2(name + ' is not a valid map index');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      l1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.k1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().o2(toString(message));
        }
        return false;
      }
      j1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.k1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().o2(toString(message));
        }
        return emptyList();
      }
      k1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.k1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().o2(toString(message));
        }
        var tmp;
        switch (index % 2 | 0) {
          case 0:
            tmp = this.r1t_1;
            break;
          case 1:
            tmp = this.s1t_1;
            break;
          default:
            // Inline function 'kotlin.error' call

            var message_0 = 'Unreached';
            throw IllegalStateException().o(toString(message_0));
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapLikeDescriptor()))
          return false;
        if (!(this.k1n() === other.k1n()))
          return false;
        if (!equals(this.r1t_1, other.r1t_1))
          return false;
        if (!equals(this.s1t_1, other.s1t_1))
          return false;
        return true;
      }
      hashCode() {
        var result = getStringHashCode(this.k1n());
        result = imul(31, result) + hashCode(this.r1t_1) | 0;
        result = imul(31, result) + hashCode(this.s1t_1) | 0;
        return result;
      }
      toString() {
        return this.k1n() + '(' + toString(this.r1t_1) + ', ' + toString(this.s1t_1) + ')';
      }
    }
    protoOf($).w1o = get_isNullable;
    protoOf($).e1p = get_isInline;
    protoOf($).g1p = get_annotations;
    initMetadataForClass($, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor()]);
    MapLikeDescriptorClass = $;
  }
  return MapLikeDescriptorClass;
}
var PrimitiveArrayDescriptorClass;
function PrimitiveArrayDescriptor() {
  if (PrimitiveArrayDescriptorClass === VOID) {
    class $ extends ListLikeDescriptor() {
      constructor(primitive) {
        super(primitive);
        this.y1t_1 = primitive.k1n() + 'Array';
      }
      k1n() {
        return this.y1t_1;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayDescriptor');
    PrimitiveArrayDescriptorClass = $;
  }
  return PrimitiveArrayDescriptorClass;
}
//region block: exports
export {
  ArrayClassDesc as ArrayClassDesc2voesact8ugbc,
  ArrayListClassDesc as ArrayListClassDesc2euexqfjnihq7,
  HashMapClassDesc as HashMapClassDesc33bep136pd9y6,
  HashSetClassDesc as HashSetClassDesc1sva99tssxbb4,
  LinkedHashMapClassDesc as LinkedHashMapClassDesc1yxtovbec4ruk,
  LinkedHashSetClassDesc as LinkedHashSetClassDesc202cqq5740j6e,
  PrimitiveArrayDescriptor as PrimitiveArrayDescriptor3bvg9e2uulc3b,
};
//endregion

//# sourceMappingURL=CollectionDescriptors.mjs.map
